import * as React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";

const root=ReactDOM.createRoot(document.getElementById('yakam'));
root.render( 
  <BrowserRouter>
      <App />
  </BrowserRouter>
)
